"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportV2Output = void 0;
const class_validator_1 = require("class-validator");
const internal_pickup_point_output_1 = require("../../pickup-area/output/internal-pickup-point.output");
const class_transformer_1 = require("class-transformer");
const point_output_1 = require("../../commons/output/point.output");
class TransportV2Output {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TransportV2Output.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TransportV2Output.prototype, "departureIata", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TransportV2Output.prototype, "arrivalIata", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TransportV2Output.prototype, "arrivalTerminal", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Number)
], TransportV2Output.prototype, "scheduledArrival", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TransportV2Output.prototype, "scheduledDeparture", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", Number)
], TransportV2Output.prototype, "estimatedArrival", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TransportV2Output.prototype, "estimatedDepature", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TransportV2Output.prototype, "intervalInMin", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], TransportV2Output.prototype, "delay", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TransportV2Output.prototype, "transportNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], TransportV2Output.prototype, "transportCarrier", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(['TRAIN', 'FLIGHT']),
    __metadata("design:type", String)
], TransportV2Output.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => internal_pickup_point_output_1.InternalPickupPointOutput),
    __metadata("design:type", internal_pickup_point_output_1.InternalPickupPointOutput)
], TransportV2Output.prototype, "pickupPoint", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => point_output_1.PointOutput),
    __metadata("design:type", point_output_1.PointOutput)
], TransportV2Output.prototype, "arrivalLocation", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], TransportV2Output.prototype, "reception", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], TransportV2Output.prototype, "nextCheckTaskId", void 0);
exports.TransportV2Output = TransportV2Output;
